export default __webpack_public_path__ + "static/exhibit-c-2-b27cc1047b65320b145734e016af42f1.jpg";